module.exports = __webpack_public_path__ + "img/my-buckets.523a6160.svg";